import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button } from "reactstrap";
import HoverImage from "react-hover-image/build";

import Drawer from "components/Drawer";
import useAxios from "hooks/useAxios";
import { faxColumns } from "utils/columns";
import FaxViewer from "components/FaxViewer";
import FaxSentIcon from "assets/icon/faxSent.svg";
import FaxForwardIcon from "assets/icon/fax-forward.svg";
import FaxForwardIconHover from "assets/icon/fax-forward-hover.svg";
import ReactStrapTable from "components/reactStrapTable";
import FaxReceivedIcon from "assets/icon/faxReceived.svg";
import EyeIcon from "assets/icon/icon-icon-options-view-patient.svg";
import EyeIconHover from "assets/icon/icon-icon-options-view-patient_hover.svg";
import FaxForwardToCE from "components/FaxForwardToCE";

const initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: "toFaxNumber",
  order: "desc",
  filters: [],
};

const FaxDetails = ({ providerIds, faxRefresh, orgId, patientId, tenantID, coveredEntityID }) => {
  const API = useAxios();
  const [state, updateState] = useState({
    isOpen: false,
    filters: initialFilters,
    faxList: [],
    records: 0,
    pdfModal: false,
    fax: {},
    isFaxForwardOpen: false,
  });
  const { isOpen, fax, faxList, filters, records, pdfModal, isFaxForwardOpen } =
    state;
  // const { patientId, coveredEntityID, tenantID } = useParams();

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  const fetchPatientFax = async (filters) => {
    try {
      const { data } = await API.post(
        `/${tenantID}/fax/PatientFax/${coveredEntityID}`,
        {
          ...filters,
          external: {
            patientId,
            providerIDs: providerIds,
          },
        }
      );
      if (data) {
        setState({
          faxList: data.items,
          records: data.totalRecords,
        });
      } else {
        setState({
          faxList: [],
          records: 0,
        });
      }
    } catch (error) {
      console.log(error);
      setState({
        faxList: [],
        records: 0,
      });
    }
  };

  useEffect(() => {
    fetchPatientFax(initialFilters);
    setState({ filters: initialFilters });
  }, [providerIds, faxRefresh]);

  const toggle = () => {
    setState({ isOpen: !isOpen });
  };

  const handleFaxForwardtoggle = () => {
    setState({ isFaxForwardOpen: !isFaxForwardOpen });
    fetchPatientFax(filters);
  };

  const handleFaxRefresh = () => {
    setState({ isFaxForwardOpen: !isFaxForwardOpen });
  };

  const arrowSign = (row) => {
    return (
      <div>
        {" "}
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-arrow-up-right"
          style={{ color: "#df1313" }}
        >
          <line x1={7} y1={17} x2={17} y2={7} />
          <polyline points="7 7 17 7 17 17" />
        </svg>
        {row.isFaxSent && (
          <div className="p-0 ms-0">
            <img src={FaxSentIcon} alt="fax sent" />
          </div>
        )}
        {row.isFaxReceived && (
          <div className="p-0 ms-0">
            <img src={FaxReceivedIcon} alt="fax sent" />
          </div>
        )}
      </div>
    );
  };

  const previewFax = (fax) => {
    const { canView } = fax;
    if (!canView) return;
    return (
      <div className="d-flex align-items-center">
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => onHandlePreviewFax(fax)}
        >
          <HoverImage
            key="EyeIcon"
            src={EyeIcon}
            hoverSrc={EyeIconHover}
            alt=""
          />
        </Button>
        <Button
          hidden={!(fax.directionID == 190001 || fax.directionID == 190003)}
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => handleFaxForwardToCE(fax)}
        >
          <HoverImage
            key="FaxForwardIcon"
            src={FaxForwardIcon}
            hoverSrc={FaxForwardIconHover}
            alt=""
          />
        </Button>
      </div>
    );
  };

  const onHandlePreviewFax = (fax) => {
    setState({
      fax,
      pdfModal: true,
    });
  };

  const handleFaxForwardToCE = (fax) => {
    setState({
      fax,
      isFaxForwardOpen: true,
    });
  };

  const columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      cellRenderer: (row) => previewFax(row),
    },
    ...faxColumns,
  ];

  const onPageChange = (pageFilter) => {
    const combinefilters = { ...filters, ...pageFilter, filters: filters.filters }
    fetchPatientFax(combinefilters);
    setState({ filters: combinefilters });
  };

  const onFilterSearch = (colFilter) => {
    const filter = { ...filters, currentPage: 1, filters: colFilter };
    // filter.filters = colFilter;
    setState({ filters: filter });
    fetchPatientFax(filter);
  };

  const onFilterCancel = () => {
    const resetFilters = {
      ...filters,
      currentPage: 1,
      filters: []
    };

    updateState(prev => ({
      ...prev,
      filters: resetFilters,
    }));

    fetchPatientFax(resetFilters);
    // fetchPatientFax(filters);
  };



  const togglePdfModal = (hasRefresh, hasCommentRefresh = false) => {
    if (hasCommentRefresh) {
      fetchPatientFax(filters);
    } else {
      setState({
        pdfModal: !pdfModal,
      });
    }
  };
  const selectedCoveredEntity = {
    tenantID: tenantID,
  };
  useEffect(() => {
    if (isOpen == true) {
      setOpen(false)
    }
    if (pdfModal == true) {
      setState({
        pdfModal: false,
      });
    }
    if (isFaxForwardOpen == true) {
      setState({ isFaxForwardOpen: false });

    }

  }, [orgId])

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };



  return (
    <div>
      <div className="table-card scroll-table position-relative border-0 pt-2">
        <ReactStrapTable
          id="fax-details"
          fixedColumn
          columns={columns}
          filters={initialFilters}
          data={faxList}
          pageSize={filters.pageSize}
          currentPage={filters.currentPage}
          totalRecords={records}
          hasPagination
          onPageChange={onPageChange}
          onPageSizeChange={onPageChange}
          onSearchColumnFilters={onFilterSearch}
          onFilterCancel={onFilterCancel}
          handleSort={onHandleSort}
        // datafilter={true}

        />
      </div>
      <Drawer
        direction="end"
        isOpen={isOpen}
        toggle={toggle}
        title="Fax Details"
      >
        <iframe
          title="1"
          src="https://www.africau.edu/images/default/sample.pdf"
          frameBorder="0"
          scrolling="auto"
          height="100%"
          width="100%"
        />

      </Drawer>
      {/* <FaxViewer
        fax={fax}
        hasReadOnly={true}
        isOpen={pdfModal}
        toggle={togglePdfModal}
        selectedCoveredEntity={{ tenantID }}
      /> */}

      <Drawer
        direction="end"
        isOpen={pdfModal}
        toggle={togglePdfModal}
        title="Fax View"
        size="lg"
      >
        <FaxViewer
          selectedCoveredEntity={selectedCoveredEntity}
          hasReadOnly={true}
          fax={fax}
          hideComments={true}
          toggle={togglePdfModal}
        ></FaxViewer>
      </Drawer>

      <Drawer
        direction="end"
        isOpen={isFaxForwardOpen}
        toggle={handleFaxForwardtoggle}
        title="Fax Forward To CE"
      >
        <FaxForwardToCE
          fax={fax}
          onClose={handleFaxForwardtoggle}
          refresh={handleFaxForwardtoggle}
          tenantID={tenantID}
        />
      </Drawer>
    </div>
  );
};

export default FaxDetails;
